import { ChevronDownIcon } from "@heroicons/react/24/outline";
import React from "react";

function AIAgentInfo() {
  return (
    <div className="w-full px-2 py-3 pb-24 overflow-y-auto">
      <div className="mx-6 my-2">
        <div className="font-bold text-2xl text-start">
          Fin 2 — DexKor’s latest generation of AI agent
        </div>
        <p className="text-sm text-gray-700 pt-1 text-start">
          Scale your support without scaling your team with Fin 2, the first AI
          agent to deliver human-quality customer service.
        </p>
        <div className="pt-5 flex items-center gap-3">
          <img
            className="w-10 h-10 border-2 border-white rounded-full"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Elon_Musk_2015.jpg/408px-Elon_Musk_2015.jpg"
            alt=""
          />
          <div className="flex flex-col text-sm text-gray-700 text-start">
            <div>Written by Anish Dhakal</div>
            <div>Updated over a month ago</div>
          </div>
        </div>
        <div className="font-normal text-base mt-6">
          <button className="flex justify-between items-center w-full px-3 py-2 border rounded-lg shadow">
            <span>Table of contents</span>
            <ChevronDownIcon className="h-4 w-4" strokeWidth={2} />
          </button>
        </div>
        <div className="mt-6 text-start text-sm">
          Fin 2 is the latest generation of Intercom’s Fin AI Agent product that
          resolves up to 82% of your support volume with human-quality,
          personalized, conversational answers. It works just like a human agent
          and resolves a higher number of more complex questions than any other
          AI agent, like explaining what’s included in a customer’s pricing
          plan, updating them on their order status, or changing a booking on
          their behalf.
        </div>
        <div className="mt-6 text-start text-sm">
          By automating your frontline support with Fin 2, you’ll free up
          thousands of hours that your existing team can now use to focus on the
          most complex issues, or transition into value-oriented roles like
          customer success.
        </div>
        <div className="mt-6 h-56">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/0EBMogwXHf0?si=dR-oyckyPCMTuzvW"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div className="mt-8 text-start text-sm">
          Fin is the best-performing and safest AI agent in customer service
          because it’s powered by the most sophisticated AI engine in customer
          service. Intercom’s patented AI Engine™ allows Fin to refine every
          query, optimize every response and validate the quality of each
          answer. As a result, it's the only AI agent that balances
          industry-high resolutions with industry-low hallucinations.
        </div>
        <div className="border rounded-lg bg-gray-200 text-sm p-5 text-start mt-8">
          Fin 2 includes powerful new features and functionality. Some of these
          features are available now, while others will be rolled out gradually
          over the coming months.{" "}
          <span className="font-bold">
            Any new or existing customers will automatically have access to Fin
            2.
          </span>
        </div>
        <button className="bg-blue-900 text-white p-2 w-56 mt-8 font-medium border rounded-md">
          Get started with Fin 2
        </button>
      </div>
    </div>
  );
}

export default AIAgentInfo;
